






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import TandaVitalEwsInput from "@/components/TandaVitalEwsInput.vue";
import { storePasien } from "@/store/modules/pasien";
import TandaVitalTable from "./TandaVitalTable.vue";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import { confirmRemove } from "@/utility/CommonHelper";
import TandaVital from "@/services/TandaVital";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    TandaVitalEwsInput,
    TandaVitalTable
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TandaVitalEws extends Vue {
  @Prop() readonly register;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  selectedTtv = [];
  selectedId = null;
  showTtvInput = false;
  showTtvGrafik = false;

  get pasienRm() {
    return storePasien.identitasPasien?.rm;
  }

  get ttvList() {
    return TandaVitalStore.list;
  }

  mounted() {
    TandaVitalStore.getByRegister(this.register);
  }

  getTandaVitalList() {
    TandaVitalStore.getByRegister(this.register);
  }

  editTtv(id) {
    this.validateUserForEdit(id, () => {
      this.copiedData = null;
      this.showTtvInput = true;
      // biar tetep update item terbaru walau id sama
      this.selectedId = 0;
      this.selectedId = id;
    });
  }

  validateUserForEdit(id, callback) {
    const ttv = this.ttvList.find(item => item.id === id);

    if (ttv?.user.id == userModule.user.id) {
      callback();
    } else {
      appModule.sendErrorAlert(
        "Tidak bisa mengubah/ menghapus catatan yang dibuat oleh orang lain"
      );
    }
  }

  removeTtv(id) {
    this.validateUserForEdit(id, () => {
      const confirm = confirmRemove("Tanda Vital");

      if (confirm) {
        TandaVital.destroy(id)
          .then(resp => {
            appModule.NoticeDelayAlert(resp.data.data.message);
          })
          .finally(() => {
            this.getTandaVitalList();
          });
      }
    });
  }

  closeInput() {
    this.showTtvInput = false;
    this.selectedId = null;
    this.copiedData = null;
  }

  copiedData = null;

  copyData(data) {
    this.copiedData = data;
    console.log(data);
  }
}
